module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/bonds.56adc6ba.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/bonds.png
// module id = 1049
// module chunks = 16